import { render } from "./ListTaxes.vue?vue&type=template&id=e27b3d00"
import script from "./ListTaxes.vue?vue&type=script&lang=js"
export * from "./ListTaxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__